import { Box } from '@mui/material';
import { CategoryScale, ChartDataset, Chart as ChartJS, Legend, LinearScale, LineElement, PointElement, Title, Tooltip } from 'chart.js';
import React from 'react';
import { Line } from 'react-chartjs-2';
import { DashFormatValue, DashLabels, DashValueFormat } from 'views/dashboard/components/Charts';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

interface IProps {
    datasets: DashLineDataset;
    labels: DashLabels[];
    height?: number | string;
    width?: number | string;
    enableTooltip?: boolean;
    valueFormat?: DashValueFormat;
    currrencySymbol?: string;
    axisYStep?: number;
    onClickDrillDown?: (index: number) => void;
}

export type DashLineDataset = ChartDataset<"line", (number | null)[]>[];


export const DashLine: React.FC<IProps> = (props) => {

    const { datasets, labels, currrencySymbol, height = 300, width = "100%", enableTooltip = true, valueFormat = "number", axisYStep, onClickDrillDown } = props;

    return (
        <Box>
            <Line
                height={height}
                width={width}
                options={{
                    responsive: true,
                    maintainAspectRatio: false,
                    clip: false,
                    onClick: (e, elements) => {
                        if (elements.length > 0) {
                            const index = elements[0].index;
                            if (onClickDrillDown) onClickDrillDown(index);
                        }
                    },
                    plugins: {
                        legend: {
                            display: false
                        },
                        tooltip: {
                            enabled: enableTooltip,
                            callbacks: {
                                title: function (item: any) {
                                    return labels[item[0].dataIndex].longLabel;
                                },
                                label: (context) => {
                                    let value = datasets[context.datasetIndex]?.data[context.dataIndex]?.valueOf() ?? 0;
                                    return DashFormatValue(value, valueFormat, currrencySymbol);
                                }
                            }
                        },
                        datalabels: {
                            display: false
                        }
                    },
                    scales: {
                        y: {
                            min: 0,
                            max: valueFormat == "percentage" ? 100 : undefined,
                            ticks: {
                                stepSize: axisYStep,
                                callback: (value, index, tick) => {
                                    return typeof (value) == "string"
                                        ? value
                                        : DashFormatValue(value, valueFormat, currrencySymbol);
                                }
                            }
                        }
                    }
                }}
                data={{
                    labels: labels.map(p => p.shortLabel),
                    datasets: datasets
                }}
            />
        </Box>
    );
};
